import React, { useEffect } from 'react';
import { map } from 'lodash';
import FilledReservation from '../Pages/FilledReservation';

export default function GraphReservationList({
  reservationSpaceData,
  divHeight
}) {
  return (
    <div className="graph-reservations">
      {map(reservationSpaceData, (lot, id) => {
        return (
          <div key={id} className="graph-column">
            <span key={id} className="graph-column__title">
              Místo&nbsp;{lot.placeNr}
            </span>
            {map(lot, (reservation, reservationId) => {
              if (reservation.height && reservation.start === 1) {
                return (
                  <FilledReservation
                    key={reservationId}
                    reservation={reservation}
                  />
                );
              }
              if (reservation.start > 1) {
                return null;
              }
              return (
                <div key={reservationId} style={{ height: divHeight }}>
                  {null}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
